import { ModuleWithProviders, NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { ChatWidgetComponent } from './components/chat-widget/chat-widget.component';
import { ChatWidgetMessageComponent } from './components/chat-widget-message/chat-widget-message.component';
import { ChatService } from './services/chat.service';
import { NgxsModule } from '@ngxs/store';
import { ChatState } from './store';
import { TimeagoFormatter, TimeagoModule } from 'ngx-timeago';
import { CustomFormatter } from './formatter/custom.formatter';
import { ChatScrollDirective } from './directives/chat-scroll.directive';
import { ChannelsPopupComponent } from './popups/channels-popup/channels-popup.component';
import { MediaPopupComponent } from './popups/media-popup/media-popup.component';
import { ScenariosPopupComponent } from './popups/scenarios-popup/scenarios-popup.component';

@NgModule({
  declarations: [
    ChatWidgetComponent,
    ChatWidgetMessageComponent,
    ChatScrollDirective,
    ChannelsPopupComponent,
    MediaPopupComponent,
    ScenariosPopupComponent,
  ],
  imports: [
    SharedModule,
    NgxsModule.forFeature([ChatState]),
    TimeagoModule.forChild({
      formatter: { provide: TimeagoFormatter, useClass: CustomFormatter },
    }),
  ],
  exports: [ChatWidgetComponent],
  providers: [ChatService],
})
export class ChatModule {
  static forChild(): ModuleWithProviders<ChatModule> {
    return {
      ngModule: ChatModule,
      providers: [ChatService],
    };
  }
}
